import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moveIssues: {
		id: 'project-directories.versions.delete-version.content.move-version.move-issues',
		defaultMessage: 'Move issues to',
		description: '',
	},
	removeVersion: {
		id: 'project-directories.versions.delete-version.content.move-version.remove-version',
		defaultMessage: 'Remove the version',
		description: '',
	},
});
